var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "zijin_dongjie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "Market-\\u6536\\u7F29",
    transform: "translate(-943.000000, -196.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12\\u5907\\u4EFD",
    transform: "translate(923.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zijin_dongjie",
    transform: "translate(20.381836, 116.381837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.10642,0 L15.238227,1.13180705 L1.13181062,15.2382235 L0,14.1063891 L14.10642,0 Z M15.0257643,3.40555826 L15.0257643,15.0257311 L3.4055666,15.0257311 L5.02796227,13.4033592 L13.4033608,13.4033592 L13.4033608,5.02796185 L15.0257643,3.40555826 Z M11.8327957,0.428747605 L10.2103921,2.05115119 L2.05115277,2.05115119 L2.05115277,10.2103894 L0.428749185,11.8327692 L0.428749185,0.428747605 L11.8327957,0.428747605 Z M8.53816413,10.1271625 L8.53845856,11.7821574 L7.06380317,11.7821574 L8.53816413,10.1271625 Z M10.3202301,8.12951513 L10.6694556,9.61962709 L8.99116413,9.61916255 L10.3202301,8.12951513 Z M5.99732809,3.78420609 L7.23728421,5.02425908 L6.10546991,6.15607338 L4.86551273,4.9161162 L5.99732809,3.78420609 Z",
    id: "Fill-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.c3b0f490d2c898b79a9c5f133469674e.svg";
export { ForwardRef as ReactComponent };